(function () {

  // ── VIDEO SLIDER ──
  const slider = document.getElementById('dribVidSlider');
  const dotsWrap = document.getElementById('dribSliderDots');
  if (!slider) return;

  const cards = slider.querySelectorAll('.drib-vid-card');
  if (!cards.length) return;

  const cardW = () => cards[0].offsetWidth + 20;
  let cur = 0;
  const total = cards.length;

  dotsWrap.innerHTML = '';
  cards.forEach(function (_, i) {
    const d = document.createElement('div');
    d.className = 'drib-sdot' + (i === 0 ? ' active' : '');
    d.addEventListener('click', function () { go(i); });
    dotsWrap.appendChild(d);
  });

  function go(n) {
    cur = Math.max(0, Math.min(n, total - 1));
    slider.style.transform = 'translateX(-' + (cur * cardW()) + 'px)';
    dotsWrap.querySelectorAll('.drib-sdot').forEach(function (d, i) {
      d.classList.toggle('active', i === cur);
    });
  }

  document.getElementById('dribSlideNext').addEventListener('click', function () {
    go(cur + 1 < total ? cur + 1 : 0);
  });
  document.getElementById('dribSlidePrev').addEventListener('click', function () {
    go(cur - 1 >= 0 ? cur - 1 : total - 1);
  });

  // ── INLINE VIDEO PLAY ──
  cards.forEach(function (card) {
    const btn = card.querySelector('.drib-vid-play');
    if (!btn) return;

    btn.addEventListener('click', function () {
      const videoId = card.getAttribute('data-video-id');
      if (!videoId || videoId.startsWith('VIDEO_ID')) return; // skip placeholders

      // Pause any other playing card first
      cards.forEach(function (other) {
        if (other !== card && other.classList.contains('is-playing')) {
          stopCard(other);
        }
      });

      // Load iframe and show it
      const iframe = card.querySelector('.drib-vid-iframe-wrap iframe');
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1';
      card.classList.add('is-playing');
    });
  });

  function stopCard(card) {
    const iframe = card.querySelector('.drib-vid-iframe-wrap iframe');
    if (iframe) iframe.src = ''; // stops playback
    card.classList.remove('is-playing');
  }

  // Stop video when slider is navigated away from that card
  document.getElementById('dribSlideNext').addEventListener('click', stopAll);
  document.getElementById('dribSlidePrev').addEventListener('click', stopAll);

  function stopAll() {
    cards.forEach(stopCard);
  }

  // ── SCROLL REVEAL ──
  const revealEls = document.querySelectorAll('.drib-reveal');
  if ('IntersectionObserver' in window) {
    const obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) e.target.classList.add('visible');
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { obs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }

  // ── INFLUENCER INLINE SHORTS ──
  const infCards = document.querySelectorAll('.drib-inf-card');

  infCards.forEach(function (card) {
    const btn = card.querySelector('.drib-inf-play');
    if (!btn) return;

    btn.addEventListener('click', function () {
      const videoId = card.getAttribute('data-video-id');
      if (!videoId || videoId.startsWith('INF_VIDEO_ID')) return; // skip placeholders

      // Stop any other playing influencer card
      infCards.forEach(function (other) {
        if (other !== card && other.classList.contains('is-playing')) {
          stopInfCard(other);
        }
      });

      // Load Shorts embed and show inline
      const iframe = card.querySelector('.drib-inf-iframe-wrap iframe');
      // YouTube Shorts use /shorts/ embed path — autoplay=1 starts immediately
      iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1&playsinline=1&showinfo=0&iv_load_policy=3&disablekb=1';
      //iframe.src = 'https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0&modestbranding=1&playsinline=1';
      card.classList.add('is-playing');
    });
  });

  function stopInfCard(card) {
    const iframe = card.querySelector('.drib-inf-iframe-wrap iframe');
    if (iframe) iframe.src = '';
    card.classList.remove('is-playing');
  }

  // ── HERO INLINE MP4 VIDEO ──

  if (heroWrap && heroPlayBtn && heroMp4) {
    heroPlayBtn.addEventListener('click', function () {

      // Show the video div first
      var vidDiv = heroWrap.querySelector('.drib-hero-vid-iframe');
      if (vidDiv) vidDiv.style.display = 'block';

      // Hide the thumbnail
      var thumb = document.getElementById('dribHeroThumb');
      if (thumb) thumb.style.display = 'none';

      // Add class for CSS state
      heroWrap.classList.add('is-playing');

      // Play with promise catch for browsers that block autoplay
      var playPromise = heroMp4.play();
      if (playPromise !== undefined) {
        playPromise.catch(function () {
          // Autoplay blocked — video is still visible with controls
          // user can press the native play button
        });
      }
    });
  }

})();



/* ══════════════════════════════════════════
   IMAGE REVIEW SLIDER LOGIC (UPDATED)
   ══════════════════════════════════════════ */
function initImageSlider() {
  const track = document.getElementById('reviewImgSlider');
  const prevBtn = document.getElementById('dribImgPrev');
  const nextBtn = document.getElementById('dribImgNext');

  // Agar elements nahi mile to aage run na kare
  if (!track || !prevBtn || !nextBtn) return;

  nextBtn.addEventListener('click', function(e) {
    e.preventDefault();
    // Har click pe exact slide size lay ga
    const slide = track.querySelector('.drib-img-slide');
    if(slide) {
      const slideWidth = slide.getBoundingClientRect().width;
      const gap = 24; // 1.5rem gap defined in CSS
      track.scrollBy({ left: slideWidth + gap, behavior: 'smooth' });
    }
  });

  prevBtn.addEventListener('click', function(e) {
    e.preventDefault();
    const slide = track.querySelector('.drib-img-slide');
    if(slide) {
      const slideWidth = slide.getBoundingClientRect().width;
      const gap = 24;
      track.scrollBy({ left: -(slideWidth + gap), behavior: 'smooth' });
    }
  });
}

// Ensure code runs regardless of how Shopify loads the script
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initImageSlider);
} else {
  initImageSlider();
}


